import { useEffect, useRef, useState } from 'react';
import MembershipLevelEdit from './MembershipLevelEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import { Space } from 'antd';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebComponent = (props: any) => {
    const apiId = 'membershipLevel';
    const ref = useRef<any>(undefined);
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();
    const [membershipTypeData, setMembershipTypeData] = useState<any>();
    const [membershipPointsPlansData, setMembershipPointsPlansData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipType',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipTypeData([{ id: 'ALLITEM', typeName: '所有类型' }, ...res.data]);
                }
            })
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'membershipPointsPlans',
                    apiExtend: 'showList'
                }
            }).then(res => {
                if (res.success) {
                    setMembershipPointsPlansData([{ id: 'ALLITEM', planName: '所有积分方案' }, ...res.data]);
                }
            })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '级别名',
            dataIndex: 'levelName',
            sorter: true
        },
        {
            title: '类型',
            dataIndex: 'membershipType',
            sorter: true,
            render: (val: any) => val?.typeName
        },
        {
            title: '积分方案',
            dataIndex: 'membershipPointsPlans',
            sorter: true,
            render: (val: any) => val?.planName
        },
        {
            title: '升级排序',
            dataIndex: 'tieredSorting',
            sorter: true,
        },
        {
            title: '进阶点',
            dataIndex: 'progressionPoints'
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员级别',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: MembershipLevelEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='membershipTypeId'
                    getListData={membershipTypeData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="typeName"
                />
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='membershipPointsPlansId'
                    getListData={membershipPointsPlansData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                    itemName="planName"
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;
